import { render, staticRenderFns } from "./material-management.vue?vue&type=template&id=497d8a1a"
import script from "./material-management.vue?vue&type=script&lang=js"
export * from "./material-management.vue?vue&type=script&lang=js"
import style0 from "./material-management.vue?vue&type=style&index=0&id=497d8a1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports